// 콤보관리(SY12) 화면 상수 — 배선(index.tsx)·검증(validate.ts)이 쓰는 문구·규칙.
import type { core } from '@musinsa/pbo-core'

/** 라우트 메뉴코드(소문자) — 권한 조회와 쿼리 키 맨 앞(탭 닫기 캐시 삭제)이 같은 값을 쓴다 */
export const MENU_CODE = 'sy12'

/** 화면관리 그리드 설정 — 표 id → gridCd(docs/conventions/grid-code.md, 1.0 SY05_HEAD 를 복사한 행). 개인 컬럼 배치 저장도 같은 값을 쓴다 */
export const TABLE_ID = 'sy12Table'
export const GRID_CDS = { [TABLE_ID]: 'SY12_HEAD' } as const

/** BE 가 비면 400 으로 거부하는 칸(LOGISPRD-17281) — 화면관리 설정이 필수를 꺼도 [저장] 이 막는다 */
export const BE_REQUIRED_KEYS: ReadonlySet<string> = new Set(['COMBO_CD', 'COMBO_OPT_CD'])

/** [저장] 필수 검사 후보 — 저장 본문에 실리는 편집 칸. required 는 화면관리 설정이 없을 때 값(1.0 SY05_HEAD COLUMN_REQ) */
export const SAVE_REQUIRED_CANDIDATES: core.CoreColumnType[] = [
  { dataIndex: 'COMBO_CD', title: '콤보코드', required: true },
  { dataIndex: 'COMBO_NM', title: '콤보명' },
  { dataIndex: 'COMBO_OPT_CD', title: '옵션코드', required: true },
  { dataIndex: 'COMBO_OPT_NM', title: '옵션명' },
]

/** 칸별 최대 길이 — MOMS_COMBO_INFO 컬럼 길이. 넘으면 BE 가 400 을 준다(LOGISPRD-17281). 순차 저장이 중간에 멈추지 않게 저장 전에 막는다. */
export const COMBO_MAX_LENGTH = { COMBO_CD: 20, COMBO_NM: 100, COMBO_OPT_CD: 20, COMBO_OPT_NM: 100 } as const

/** 표 페이지 크기 — '몇 개씩' 미노출 = 10,000개씩(MOMS·MWMS 공통 규칙 2026-08-24) */
export const SY12_PAGE_SIZE = 10000

export const MESSAGES = {
  noSelection: '저장할 행을 선택해 주세요.',
  /** 필수 칸 제목은 화면관리 설정을 반영한 별표에서 온다 */
  requiredCells: (titles: string[]) => `${titles.join('·')} 칸은 필수입니다.`,
  tooLong: `콤보코드·옵션코드는 ${COMBO_MAX_LENGTH.COMBO_CD}자, 콤보명·옵션명은 ${COMBO_MAX_LENGTH.COMBO_NM}자까지 입력할 수 있습니다.`,
  /** BE 문구가 없을 때 — 빈 body 응답은 HTTP 상태를 함께 노출(공통코드 화면 규약) */
  apiFailed: (status?: number) =>
    status ? `요청을 처리하지 못했습니다(HTTP ${status}). 잠시 후 다시 시도하세요.` : '요청을 처리하지 못했습니다. 잠시 후 다시 시도하세요.',
  /** 행별 순차 처리 중 실패 — 실패 지점에서 멈추므로 앞의 done 건은 이미 반영됐다. */
  partialFailed: (total: number, done: number, reason: string) => `${total}건 중 ${done}건 반영 후 실패했습니다. ${reason}`,
} as const
